import { QUESTIONS, SECTIONS } from './questions.js';

const titleCase = (value) => String(value || '').replace(/[-_]/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
const hasValue = (value) => Array.isArray(value) ? value.length > 0 : String(value || '').trim() !== '';

function renderSummaryRows(state) {
  return QUESTIONS.filter((question) => hasValue(state.answers[question.id])).slice(0, 8).map((question) => {
    const value = state.answers[question.id];
    return `<li><strong>${question.question}:</strong> ${Array.isArray(value) ? value.join(', ') : value}</li>`;
  }).join('');
}

function getStepLabel(state) {
  if (state.currentStep < 0) {
    return 'Welcome';
  }
  return SECTIONS[state.currentStep]?.title || 'Draft review';
}

export function updatePreview({ state, elements }) {
  const childName = String(state.answers.childName || '').trim();
  const answered = Object.values(state.answers).filter(hasValue).length;
  elements.renderedHandbook.innerHTML = `
    <section class="handbook-cover-preview">
      <div class="cover-header-group">
        <div class="editorial-wordmark"><span>G e n t l e</span><span class="divider">•</span><span>C o n n e c t i o n s</span></div>
        <h2 class="cover-title">${childName || 'Your'} Draft Summary</h2>
        <p class="cover-subtitle">Live questionnaire summary for your eventual server-side handbook generation</p>
      </div>
      <div class="cover-details">
        <div class="detail-block"><strong>Active step</strong>${getStepLabel(state)}</div>
        <div class="detail-block"><strong>Answered prompts</strong>${answered}</div>
        <div class="detail-block"><strong>Educator role</strong>${titleCase(state.answers.educatorRole || 'Not set')}</div>
        <div class="detail-block"><strong>Age band</strong>${titleCase(state.answers.ageBand || 'Not set')}</div>
      </div>
    </section>
    <section class="handbook-section">
      <h3>Current answers snapshot</h3>
      <ul>${renderSummaryRows(state) || '<li>Your answers will appear here as you move through the wizard.</li>'}</ul>
    </section>`;
}

export function toggleMobileTab({ state, elements }, tab) {
  state.activeTab = tab;
  elements.tabForm.classList.toggle('active', tab === 'form');
  elements.tabPreview.classList.toggle('active', tab === 'preview');
  elements.appWorkspace.classList.toggle('show-preview', tab === 'preview');
  if (tab === 'preview') {
    elements.previewContainer.scrollTop = 0;
  }
}
